export default __webpack_public_path__ + "static/media/Omniva.a2a151fa.svg";